export enum GeoDivision {
  COMPANY = 10,
  REGION = 20,
  GROUP = 30,
  LOCATION = 40,
}
